import { SubmitButton, toast } from "@bleu.builders/ui";
import { serialize } from "object-to-formdata";
import React from "react";
import useSWRMutation from "swr/mutation";

import { useOrganization } from "#/contexts/OrganizationContext";
import { fetcher } from "#/lib/fetcher";
import { UserPagePath } from "#/lib/pagesHelper";

export function ActiveCheckoutLinkBanner() {
  const organization = useOrganization();
  const { trigger, isMutating } = useSWRMutation(
    UserPagePath.ORGANIZATION_GATEWAY_CHECKOUT,
    fetcher,
  );

  const onClick = async () => {
    const formData = serialize({
      checkout_link_id: organization?.active_checkout_link,
    });

    const result = await trigger({ formData, method: "POST" });

    if (!result.success) {
      toast({
        title: "Erro!",
        description: result.errors,
        variant: "destructive",
      });
      return;
    }

    const url = result?.url;
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("target", "_blank");
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };

  return (
    organization?.are_billing_info_complete &&
    organization?.active_checkout_link && (
      <div className="text-center bg-orange-500 text-destructive-foreground px-6 py-2.5 sm:px-3.5 sm:before:flex-1 text-sm leading-6 font-semibold">
        Sua assinatura tem uma cobrança pendente.{" "}
        <SubmitButton
          variant="ghost"
          size="sm"
          className="ml-2 bg-accent text-accent-foreground hover:underline"
          onClick={onClick}
          isSubmitting={isMutating}
        >
          Ver cobrança
        </SubmitButton>
      </div>
    )
  );
}
